/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "customer-depot-discount-groups-management",
	data() {
		return {
			depotDiscountGroups: [],
			depotDiscountGroupsHeadings: [
				{
					text: "Name",
					field: "name"
				},
				{
					text: "Depot",
					field: "depot"
				},
				{
					text: "Discount Amount",
					field: "discountAmountAsString"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			depots: [],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				linkProducts: "linkProducts",
				linkCustomers: "linkCustomers"
			},
			initialiseDate: true,
			customerDiscountGroupAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditCustomerDiscountGroupModal",
				heading: "Add Customer Discount Group",
				customerDiscountGroup:{
					customerDiscountGroupId: null,
					isActive: true,
					depotId:{
						value: null,
						hasError: false,
						errorMessage: null
					},
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					discountAmount: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					effectiveDate: {
						value: new Date(),
						hasError: false,
						errorMessage: null
					}
				}
			},
			customerDiscountGroupMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markCustomerDiscountGroupAsActiveInactiveModal",
				heading: "Mark Customer Discount Group As Active/Inactive",
				isActive: null,
				customerDiscountGroupId: null
			},
			linkProductsToDiscountGroupModal: {
				showModal: false,
				isSaving: false,
				modalId: "linkProductsToDiscountGroupModal",
				heading: "Link Products To Discount Group",
				customerDiscountGroupId: null,
				depotId: null
			},
			filterStateChanged: false,
			filter:{
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				depotId: null
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getDepotDiscountGroups(){
			this.loading = true;
			let request ={
				searchQuery: this.filter.customerSearchQuery,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				depotId: this.filter.depotId
			};
			orderService.getDepotDiscountGroups(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depotDiscountGroups = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						for(let i = 0; i < this.depotDiscountGroups.length; i++) {
							this.depotDiscountGroups[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit
								},
								{
									name: this.depotDiscountGroups[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								},
								// {
								// 	name: "Link Products",
								// 	key: this.actionKeys.linkProducts
								// },
								// {
								// 	name: "Link Customers",
								// 	key: this.actionKeys.linkCustomers
								// }
							];
							this.depotDiscountGroups[i].discountAmountAsString = currencyHelper.numberToCurrency(this.depotDiscountGroups[i].discountAmount);
						}
						this.depotDiscountGroups = dataTableHelper.castFieldValues(this.depotDiscountGroups);
						this.filterStateChanged = false;
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getDepots(){
			this.loading = true;
			let request = {
				isActive: true,
				provinceId: 0
			};
			systemService.getAllDepots(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.depots = successResponse.data.result;
						this.depots = $.map(this.depots,
							function (obj) {
								obj.id = obj.id || obj.depotId;
								obj.text = obj.text || obj.name;
								return obj;
							});
						this.depots.unshift({
							depotId: 0,
							id: 0,
							text: "All"
						});
						this.depots = dataTableHelper.castFieldValues(this.depots);
						this.filter.depotId = this.depots[0].depotId;
						this.getDepotDiscountGroups();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onDepotFilterSelect(depot){
			if(this.filter.depotId !== depot.id){
				this.filterStateChanged = true;
			}
			this.filter.depotId = depot.id;
			//this.getDepotProducts();
		},
		onFilterSearchClicked(){
			this.getDepotDiscountGroups();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
		},
		onAddCustomerDiscountGroupClick(){
			// this.customerDiscountGroupAddEditFormModal.heading = "Add Customer Depot Discount Group";
			// this.clearCustomerDiscountGroupModel();
			// this.customerDiscountGroupAddEditFormModal.showModal = true;
			this.$router.push("/pricing/collection/customerDepotDiscountGroups/addOrEditDepotDiscountGroup");
		},
		onCustomerDiscountGroupActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					// this.customerDiscountGroupAddEditFormModal.showModal = true;
					// this.customerDiscountGroupAddEditFormModal.heading = "Edit Customer Depot Discount Group";
					// this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.name.value = actionAndData.data.name;
					// this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.value = actionAndData.data.discountAmount;
					// this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.customerDiscountGroupId = actionAndData.data.depotDiscountGroupId;
					// this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					// this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.effectiveDate.value = moment(actionAndData.data.effectiveDate, "DD/MM/YYYY").toDate()
					// this.initialiseDate = true;
					// this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.depotId.value = actionAndData.data.depotId;
					this.$router.push("/pricing/collection/customerDepotDiscountGroups/addOrEditDepotDiscountGroup/" + actionAndData.data.depotDiscountGroupId);
					break;
				case this.actionKeys.markAsActiveInactive:
					this.customerDiscountGroupMarkAsActiveInactiveModal.showModal = true;
					this.customerDiscountGroupMarkAsActiveInactiveModal.customerDiscountGroupId = actionAndData.data.depotDiscountGroupId;
					this.customerDiscountGroupMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.customerDiscountGroupMarkAsActiveInactiveModal.heading = "Mark Customer Depot Discount Group As " + (this.customerDiscountGroupMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " + actionAndData.data.name;
					break;
				case this.actionKeys.linkProducts:
					this.linkProductsToDiscountGroupModal.showModal = true;
					this.linkProductsToDiscountGroupModal.heading = "Link Products To Depot Discount Group - " + actionAndData.data.name + " - " + actionAndData.data.depot;
					this.linkProductsToDiscountGroupModal.customerDiscountGroupId = actionAndData.data.depotDiscountGroupId;
					this.linkProductsToDiscountGroupModal.depotId = actionAndData.data.depotId;
					break;
				case this.actionKeys.linkCustomers:
					this.$router.push("/pricing/collection/customerDepotDiscountGroups/linkProductsToCustomerDepotDiscountGroup/" + actionAndData.data.depotDiscountGroupId);
			}
		},
		onPagingUpdated(pagingDetails){
			this.pagingDetails.pageNumber = pagingDetails.pageNumber;
			this.getDepotDiscountGroups();
		},
		onMarkCustomerDiscountGroupActiveInactiveSelected(isActive){
			this.customerDiscountGroupMarkAsActiveInactiveModal.isActive = isActive;
			console.log("customerDiscountGroupMarkAsActiveInactiveModal.isActive", this.customerDiscountGroupMarkAsActiveInactiveModal.isActive);
		},
		onDepotSelect(depot){
			this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.depotId.value = depot.id;
			this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.depotId.hasError = false;
			this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.depotId.errorMessage = null;
		},
		onEffectiveDateSelected(effectiveDate){
			console.log("effectiveDate", effectiveDate);
			this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.effectiveDate.value = effectiveDate;
			this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.effectiveDate.hasError = false;
			this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.effectiveDate.errorMessage = null;
			this.initialiseDate = false;
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.customerDiscountGroupMarkAsActiveInactiveModal.isSaving = true;
			let request ={
				depotDiscountGroupId: this.customerDiscountGroupMarkAsActiveInactiveModal.customerDiscountGroupId,
				isActive: markAsActive
			};
			orderService.markDepotDiscountGroupAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getDepotDiscountGroups();
						this.customerDiscountGroupMarkAsActiveInactiveModal.showModal = false;
					}
					this.customerDiscountGroupMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					this.customerDiscountGroupMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onAddOrEditCustomerDiscountGroupModalCloseClick(){
			this.customerDiscountGroupAddEditFormModal.showModal = false;
			this.clearCustomerDiscountGroupModel();
		},
		onAddOrEditCustomerDiscountGroupSaveClick(){
			this.customerDiscountGroupAddEditFormModal.isSaving = true;
			let request ={
				depotDiscountGroupId: this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.customerDiscountGroupId === null ? 0 : this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.customerDiscountGroupId,
				name: this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.name.value,
				discountAmount: this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.value === null ? 0 : this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.value,
				isActive: this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.isActive,
				depotId: this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.depotId.value === null ? 0 : this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.depotId.value,
				effectiveDate: this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.effectiveDate.value
			};
			orderService.addOrUpdateDepotDiscountGroup(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.depotDiscountGroupValidationResponse.valuesAreValid){
							this.getDepotDiscountGroups();
							this.clearCustomerDiscountGroupModel();
							this.customerDiscountGroupAddEditFormModal.showModal = false;
						}
						else{
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.name.hasError = successResponse.data.depotDiscountGroupValidationResponse.nameValidationResponse.hasError;
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.name.errorMessage = successResponse.data.depotDiscountGroupValidationResponse.nameValidationResponse.message;
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.hasError = successResponse.data.depotDiscountGroupValidationResponse.discountAmountValidationResponse.hasError;
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.discountAmount.errorMessage = successResponse.data.depotDiscountGroupValidationResponse.discountAmountValidationResponse.message;
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.depotId.hasError = successResponse.data.depotDiscountGroupValidationResponse.depotValidationResponse.hasError;
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.depotId.errorMessage = successResponse.data.depotDiscountGroupValidationResponse.depotValidationResponse.message;
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.effectiveDate.hasError = successResponse.data.depotDiscountGroupValidationResponse.effectiveDateValidationResponse.hasError;
							this.customerDiscountGroupAddEditFormModal.customerDiscountGroup.effectiveDate.errorMessage = successResponse.data.depotDiscountGroupValidationResponse.effectiveDateValidationResponse.message;
						}
					}
					this.customerDiscountGroupAddEditFormModal.isSaving = false;
				},
				errorResponse => {
					this.customerDiscountGroupAddEditFormModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onLinkProductsToCustomerGroupModalOkClick(){
			this.linkProductsToDiscountGroupModal.showModal = false;
			this.linkProductsToDiscountGroupModal.customerDiscountGroupId = 0;
		},
		clearCustomerDiscountGroupModel(){
			this.customerDiscountGroupAddEditFormModal.customerDiscountGroup = {
				customerDiscountGroupId: null,
				isActive: true,
				depotId:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				name: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				discountAmount: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				effectiveDate: {
					value: new Date(),
					hasError: false,
					errorMessage: null
				}
			}
			this.initialiseDate = true;
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Depot Special Pricing");
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Pricing"
			};
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Depot Special Pricing"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getDepots();
	}
};